import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { CheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import { SettingsBox } from 'src/Elements/Data'
import { useUserSettings } from 'src/Hooks'
import { MASTER_IS_OFFLINE_KEY } from 'src/Libs/dynamic-power-prices/const'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  settingsBox: {
    margin: theme.spacing(2),
  },
}))

interface Props {
  isServerOffline: boolean
}

/**
 * This component renders the opt-in section of the dynamic prices settings.
 * It allows the user to opt-in to dynamic prices even if the country does not support it.
 */
const FormOptIn: React.FC<Props> = ({ isServerOffline }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const descriptionText = t('systemSettings.dynamic-prices.opt-in.description')
  const checkboxText = t('systemSettings.dynamic-prices.opt-in.checkbox-text')
  const buttonText = t('systemSettings.dynamic-prices.opt-in.button')
  const { updateUserSettings } = useUserSettings()
  const [isOptIn, setIsOptIn] = useState(false)

  const handleOptInChange = (newValue: boolean): void => {
    setIsOptIn(newValue)
  }

  const handleRequestFeatureAccess = (): void => {
    updateUserSettings({ didOptInToGermanDynamicPrices: isOptIn })
  }

  const description = (
    <Box>
      <Typography variant="body2">{descriptionText}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center' }}>
        <CheckboxField value={isOptIn} onChange={handleOptInChange} />
        <Typography variant="body2" sx={{ mt: 1 }}>
          {checkboxText}
        </Typography>
      </Box>
    </Box>
  )

  const accordionTitle = t('systemSettings.price-based-charging.section-title')

  return (
    <OptionalTooltipWrapper hasTooltip={isServerOffline} placement={'top'} titleKey={MASTER_IS_OFFLINE_KEY}>
      <AccordionItem expanded={!isServerOffline} disabled={isServerOffline} title={accordionTitle}>
        <SettingsBox
          title={t('systemSettings.dynamic-prices.opt-in.title')}
          description={description}
          suffix={
            <Button onClick={handleRequestFeatureAccess} disabled={!isOptIn}>
              {buttonText}
            </Button>
          }
          className={classes.settingsBox}
        />
      </AccordionItem>
    </OptionalTooltipWrapper>
  )
}

export default FormOptIn
